<template>
   <div>
     <module-card title="筛选">
       <el-form :model="searchForm" :inline="true">
         <el-form-item label="指派日期">
           <date-range-picker :value="inputTime" @getChange="value => inputTime = value" :clearable="true"></date-range-picker>
         </el-form-item>
         <el-form-item label="活动编号">
           <el-input v-model.trim="searchForm.activityId" placeholder="请输入活动编号" :clearable="true"></el-input>
         </el-form-item>
         <el-form-item label="活动名称">
           <el-input v-model.trim="searchForm.activityName" placeholder="请输入活动名称" clearable></el-input>
         </el-form-item>
         <el-form-item label="开卡状态">
           <el-select v-model="searchForm.status" class="form-input" clearable>
              <el-option v-for="item in statusList" :key="item.value" :label="item.text" :value="item.value"></el-option>
            </el-select>
         </el-form-item>
         <el-form-item label="商户编号">
           <el-input v-model.trim="searchForm.merchantId" placeholder="请输入商户编号" clearable></el-input>
         </el-form-item>
         <el-form-item label="银行编号">
           <el-input v-model.trim="searchForm.bankCode" placeholder="请输入银行编号" clearable></el-input>
         </el-form-item>
         <el-form-item label="银行经理手机号">
           <el-input v-model.trim="searchForm.managerPhone" placeholder="请输入银行经理手机号" clearable></el-input>
         </el-form-item>
         <el-form-item label="银行经理乐刷编号">
           <el-input v-model.trim="searchForm.managerId" placeholder="请输入银行经理乐刷编号" clearable></el-input>
         </el-form-item>
         <el-form-item>
           <el-button type="primary" icon="el-icon-search" :loading="searchLoading" @click="searchBtnClick">查询</el-button>
         </el-form-item>
       </el-form>
     </module-card>
     <module-card title="开卡指派记录">
       <el-table border :data="tableData" v-loading="searchLoading">
         <el-table-column v-for="item in columns" :label="item.label" :prop="item.key" :key="item.key"></el-table-column>
         <el-table-column label="操作" width="160">
           <template slot-scope="scope">
             <auth-button auth-type="span" opt="assignment_record" label="指派记录" @click.native="checkAssignmentRecord(scope.row)"></auth-button>
             <auth-button auth-type="span" opt="assignment_update" label="变更指派" @click.native="updateAssignment(scope.row)"></auth-button>
           </template>
         </el-table-column>
       </el-table>
       <pagination
        :count="total"
        :edit-size="true"
        :page-no="pageNo"
        :size="pageSize"
        @changePage="value => { pageNo = value;getTableList() }"
        @changeSize="value => { pageSize = value;pageNo = 1;getTableList() }"
      ></pagination>
      <dialog-info
        title="开卡指派变更记录"
        :visible.sync="showAssignmentRecordDialog"
        :showCancelBtn="false"
        size="large"
        footerAlign="center"
        @confirm="showAssignmentRecordDialog=false"
      >
        <el-table border :data='recordsData' v-loading="recordLoading">
          <el-table-column label='序号' type="index" width="60"></el-table-column>
          <el-table-column v-for="item in recordsColumns" :label="item.label" :prop="item.key" :key="item.key"></el-table-column>
        </el-table>
        <pagination
        :count="recordsPagination.total"
        :edit-size="true"
        :page-no="recordsPagination.pageNo"
        :size="recordsPagination.pageSize"
        @changePage="value => { recordsPagination.pageNo = value;getAssignRecordData() }"
        @changeSize="value => { recordsPagination.pageSize = value;recordsPagination.pageNo = 1;getAssignRecordData() }"
      ></pagination>
      </dialog-info>
      <dialog-info
        title="变更开卡指派"
        footerAlign="center"
        :showCancelBtn="false"
        :visible.sync="showUpdateAssignmentDialog"
        @confirm="doUpdateAssignment">
          <el-form :model="updateAssignmentForm" label-width="100px">
            <el-form-item label="银行网点" prop="bankCode">
              <el-select v-model="updateAssignmentForm.bankCode"  @change="handleAssignmentBankChange" clearable>
                <el-option
                  v-for="item in bankList"
                  :key="item.bankNewId"
                  :label="item.bankName"
                  :value="item.bankNewId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="网点银行经理" prop="managerId">
              <el-select v-model="updateAssignmentForm.managerId">
                <el-option
                  v-for="item in managerList"
                  :key="item.managerId"
                  :label="item.name"
                  :value="item.managerId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
      </dialog-info>
     </module-card>
   </div>
</template>

<script>
import dateRangePicker from '@/components/dateRangePicker'
import pagination from '@/components/pagination'
import dialogInfo from '@/components/layout/dialogInfo'
export default {
  name: 'OpenCardAssignmentRecords',
  components: { dateRangePicker, pagination, dialogInfo },

  data () {
    return {
      inputTime: [],
      searchForm: {
        activityId: '',
        activityName: '',
        status: '',
        merchantId: '',
        bankCode: '',
        managerPhone: '',
        managerId: ''
      },
      statusList: [{
        text: '未预约',
        value: 10
      }, {
        text: '已指派',
        value: 50
      }, {
        text: '已预约',
        value: 20
      }, {
        text: '已开卡',
        value: 30
      }, {
        text: '已绑卡',
        value: 40
      }, {
        text: '无效',
        value: 0
      },
      { text: '全部', value: '' }
      ],
      columns: [
        { label: '活动名称', key: 'activityName' },
        { label: '活动编号', key: 'activityId' },
        { label: '活动银行', key: 'activityBankName' },
        { label: '商户编号', key: 'merchantId' },
        { label: '商户名称', key: 'merchantName' },
        { label: '商户地址', key: 'merchantAddress' },
        { label: '最新指派时间', key: 'assignTime' },
        { label: '银行经理', key: 'managerName' },
        { label: '银行经理手机号', key: 'managerPhone' },
        { label: '银行经理乐刷编号', key: 'managerId' },
        { label: '银行网点', key: 'cardBankName' },
        { label: '银行编号', key: 'cardBankCode' },
        { label: '开卡状态', key: 'statusName' },
        { label: '操作人', key: 'operator' }
      ],
      searchLoading: false,
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      showAssignmentRecordDialog: false,
      recordsData: [],
      recordLoading: false,
      recordsPagination: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      recordsColumns: [
        { label: '时间', key: 'createTime' },
        { label: '银行网点', key: 'bankName' },
        { label: '网点银行经理', key: 'managerName' },
        { label: '操作人', key: 'operator' }
      ],
      showUpdateAssignmentDialog: false,
      updateAssignmentForm: {
        bankCode: '',
        managerId: ''
      },
      checkAssignRecordInfo: null,
      bankList: [],
      managerList: []
    }
  },
  computed: {},

  created () {
    // this.searchBtnClick()
  },

  mounted () {},

  methods: {
    searchBtnClick () {
      this.pageNo = 1
      this.getTableList()
    },
    getTableList () {
      const params = {
        ...this.searchForm,
        assignTimeStart: this.inputTime && this.inputTime.length ? this.inputTime[0] : '',
        assignTimeEnd: this.inputTime && this.inputTime.length ? this.inputTime[1] : '',
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.tableData = []
      this.total = 0
      this.searchLoading = true
      this.$axios.post(this.$api.queryAssignPageList, params).then(res => {
        this.searchLoading = false
        if (res.respCode === '0') {
          this.tableData = res.data.list
          this.total = res.data.count
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    checkAssignmentRecord (row) {
      this.showAssignmentRecordDialog = true
      this.recordsPagination.pageNo = 1
      this.checkAssignRecordInfo = row
      this.getAssignRecordData()
    },
    getAssignRecordData () {
      const params = {
        activityId: this.checkAssignRecordInfo.activityId,
        merchantId: this.checkAssignRecordInfo.merchantId,
        ...this.recordsPagination
      }
      this.recordLoading = true
      this.$axios.post(this.$api.queryAssignRecordList, params).then(res => {
        this.recordLoading = false
        if (res.respCode === '0') {
          this.recordsData = res.data.list
          this.recordsPagination.total = res.data.count
        } else {
          this.recordsData = []
          this.recordsPagination.total = 0
        }
      })
    },
    updateAssignment (row) {
      this.showUpdateAssignmentDialog = true
      this.checkAssignRecordInfo = row
      this.getBankByMerchantId()
      this.updateAssignmentForm.bankCode = row.cardBankCode
      this.handleAssignmentBankChange(row.cardBankCode)
      this.updateAssignmentForm.managerId = row.managerId
    },
    getBankByMerchantId () {
      this.$axios.post(this.$api.queryBankByMerchantId, {
        activityId: this.checkAssignRecordInfo.activityId
      }).then(res => {
        if (res.respCode === '0') {
          this.bankList = res.data
        }
      })
    },
    handleAssignmentBankChange (value) { // 开卡指派弹框银行网点下拉选项改变
      this.$set(this.updateAssignmentForm, 'managerId', '')
      if (!value) {
        this.managerList = []
        this.updateAssignmentForm.bankCode = ''
        return
      }
      this.$axios.post(this.$api.queryManager, {
        newCode: value
      }).then(res => {
        if (res.respCode === '0') {
          this.managerList = res.data
        }
      })
    },
    doUpdateAssignment () {
      const params = {
        ...this.updateAssignmentForm,
        activityId: this.checkAssignRecordInfo.activityId,
        merchantId: this.checkAssignRecordInfo.merchantId
      }
      this.$axios.post(this.$api.updateAssign, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: '操作成功'
          })
          this.showUpdateAssignmentDialog = false
          this.getTableList() // 刷新列表
        }
      })
    }
  }
}
</script>
<style lang='css' scoped>

</style>
